module.exports = __webpack_public_path__ + "img/icon_empty.a25e78f5.png";